import { LoadingController } from '@ionic/angular';
import { WagerApi } from 'src/app/core/api/wager-api';
import { AnalyticsService } from 'src/app/core/services/analytics/analytics.service';
import { EventName } from 'src/app/core/services/analytics/event-names';
import { HttpService } from 'src/app/core/services/http/http.service';

export async function scoreSubmitter(
  context: string,
  message: string,
  roomId: string,
  moves: string[],
  loadingController: LoadingController,
  httpService: HttpService,
  analyticsService: AnalyticsService,
) {
  const loading = await loadingController.create({
    message,
    cssClass: 'custom-loading',
  });
  loading.present();

  return new Promise((resolve, reject) => {
    const interval = setInterval(async () => {
      clearInterval(interval);
      try {
        analyticsService.log(EventName.SubmitScore, {
          roomId: roomId,
          moves: moves.toString(),
          context,
        });
        await WagerApi.request(httpService).finishRound(roomId, moves);
        await loading.dismiss();
        analyticsService.log(EventName.MatchFinished, { roomId });
        resolve(true);
      } catch (error) {
        await analyticsService.handleError(
          error,
          `catch_finish_round_${context}, room: ${roomId}`,
          {
            roomId: roomId,
            moves: moves.toString(),
            context,
          },
        );
        await loading.dismiss();
        reject(false);
      }
    }, 1000);
  });
}
